import * as React from 'react';
import { createContext, useContext, useState, Dispatch, SetStateAction } from 'react';
import { IData } from '../types';

/** Tuple returned by {@link useFilterList}: the current filter list state and its setter. */
type FilterListContextValue = [IData, Dispatch<SetStateAction<IData>>];

const FilterListContext = createContext(undefined as unknown as FilterListContextValue);

export const FilterListProvider = ({ children }: { children: React.ReactNode }) => {
    const [filterList, setFilterList] = useState<IData>({ _toggleFilter: false });

    return (
        <FilterListContext.Provider value={[filterList, setFilterList]}>
            {children}
        </FilterListContext.Provider>
    );
};

export const useFilterList = (): FilterListContextValue => useContext(FilterListContext);
